import i18n, { AVAILABLE_LANGUAGES } from '../../i18n'

export const getUrlWithCurrentLanguage = (to: string) => `/${i18n.language}/${to}`

export const getCurrentRouteWithoutLanguageFromPathname = (pathname: string) =>
	pathname
		.replace(new RegExp(AVAILABLE_LANGUAGES.map((el) => `/${el}`).join('|')), '')
		.replace('/', '')
